import NoImage from './NoImage';

const OptionViewDetailImage = imageInfo => {
  const { optionDetailImg, optionTitle  } = imageInfo;
  if (!optionDetailImg) return NoImage('g');

  const src = `https://img1.tmon.kr${optionDetailImg}`;
  const alt = optionTitle || '상품 상세 이미지';
  const onError = `$(this).parent().addClass('no-image');$(this).remove()`;
  return `<div><img src="${src}" alt="${alt}" onError="${onError}"></div>`;
};

export default OptionViewDetailImage;
